import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable, throwError } from "rxjs";
import { UtilService } from "../service/util.service";
import { SeguridadService } from "../service/seguridad.service";


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(private seguridadService: SeguridadService,
    private utilService: UtilService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const safeMethods = ['GET', 'HEAD', 'OPTIONS'];
    if (
      this.seguridadService.isReadOnly() &&
      req.url.includes('/api/') &&
      !safeMethods.includes(req.method)
    ) {
      const message = 'El modo consulta no permite modificar información.';
      this.utilService.alertWarnning(message);
      return throwError(
        () =>
          new HttpErrorResponse({
            status: 403,
            statusText: 'Forbidden',
            url: req.url,
            error: { message },
          })
      );
    }

    let token;
    token = this.seguridadService.getToken();

    if (token) {
      if (!this.seguridadService.isAuthenticated()) {
        //this.utilService.alertWarnning('Al no encontrar actividad, hemos cerrado tu sesión.');
        //this.utilService.link(URL_COMUN.URL_LOGIN);
      }
    }
    return next.handle(req);
  }

}